import universal from 'react-universal-component';

export default universal(() => import('./Edit'));



// WEBPACK FOOTER //
// ./src/app/views/Custom/Edit/index.js